import { render, staticRenderFns } from "./exhibition-release-new-reject.vue?vue&type=template&id=49ad3af2&scoped=true&"
import script from "./exhibition-release-new-reject.vue?vue&type=script&lang=js&"
export * from "./exhibition-release-new-reject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ad3af2",
  null
  
)

export default component.exports